export enum UTMParameters {
    UTM_SOURCE = 'utm_source',
    UTM_MEDIUM = 'utm_medium',
    UTM_CAMPAIGN = 'utm_campaign',
    UTM_TERM = 'utm_term',
    UTM_CONTENT = 'utm_content',
}

export const captureUTMParameters = () => {
    const urlParams = new URLSearchParams(window.location.search)
    const utm = {
        [UTMParameters.UTM_SOURCE]: urlParams.get(UTMParameters.UTM_SOURCE),
        [UTMParameters.UTM_MEDIUM]: urlParams.get(UTMParameters.UTM_MEDIUM),
        [UTMParameters.UTM_CAMPAIGN]: urlParams.get(UTMParameters.UTM_CAMPAIGN),
        [UTMParameters.UTM_TERM]: urlParams.get(UTMParameters.UTM_TERM),
        [UTMParameters.UTM_CONTENT]: urlParams.get(UTMParameters.UTM_CONTENT),
    }

    Object.entries(utm).forEach(([key, value]) => {
        if (value) sessionStorage.setItem(key, value)
    })
}

export const getStoredUTMParameters = () => {
    const utm = {
        [UTMParameters.UTM_SOURCE]: sessionStorage.getItem(UTMParameters.UTM_SOURCE),
        [UTMParameters.UTM_MEDIUM]: sessionStorage.getItem(UTMParameters.UTM_MEDIUM),
        [UTMParameters.UTM_CAMPAIGN]: sessionStorage.getItem(UTMParameters.UTM_CAMPAIGN),
        [UTMParameters.UTM_TERM]: sessionStorage.getItem(UTMParameters.UTM_TERM),
        [UTMParameters.UTM_CONTENT]: sessionStorage.getItem(UTMParameters.UTM_CONTENT),
    }

    const allNull = Object.values(utm).every((v) => v === null)
    return allNull ? undefined : utm
}
